import React from 'react';
import PingStatus from './PingStatus';

export default function ZDownload() {
  return (
    <PingStatus
      pingUrl="https://v1-csapi.compsoft.com.br:825/ping"
      restartKey="download"
      interval={10000}
    />
  );
}
